import React, { useEffect, useState } from "react";

import API from "../../../services/api";

import EarningsSummary from "../../../components/delivery/Earnings/EarningsSummary";
import WeeklyChart from "../../../components/delivery/Earnings/WeeklyChart";
import TransactionCard from "../../../components/delivery/Earnings/TransactionCard";
import IncentiveCard from "../../../components/delivery/Earnings/IncentiveCard";
import WithdrawalCard from "../../../components/delivery/Earnings/WithdrawalCard";

import "./Earnings.css";

function Earnings() {

    const [dashboard, setDashboard] = useState(null);

    const [weeklyData, setWeeklyData] = useState([]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {

        fetchData();

    }, []);

    const fetchData = async () => {

        try {

            const [

                dashboardResponse,

                weeklyResponse,

            ] = await Promise.all([

                API.get("/delivery/earnings/dashboard"),

                API.get("/delivery/earnings/weekly"),

            ]);

            if (dashboardResponse.data.success) {

                setDashboard(
                    dashboardResponse.data.dashboard
                );

            }

            if (weeklyResponse.data.success) {

                setWeeklyData(
                    weeklyResponse.data.analytics
                );

            }

        }

        catch (error) {

            console.log(error);

        }

        finally {

            setLoading(false);

        }

    };

    if (loading) {

        return (

            <div
                style={{
                    textAlign: "center",
                    padding: "40px",
                }}
            >

                Loading...

            </div>

        );

    }

    return (

        <div className="delivery-earnings-page">

            <div className="earnings-header">

                <h1>

                    Earnings

                </h1>

                <p>

                    Track your income and performance.

                </p>

            </div>

            <EarningsSummary

                dashboard={dashboard}

            />

            <WeeklyChart

                data={weeklyData}

            />

            <TransactionCard />

            <IncentiveCard />

            <WithdrawalCard />

        </div>

    );

}

export default Earnings;